export const scrollToTop = (topOffset = 0, smooth = false) => {
  setTimeout(() => {
    window.scrollTo({
      top: topOffset,
      left: 0,
      behavior: smooth ? 'smooth' : 'instant',
    });
  });
};
